import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const AddPDF = ({ language, refs }) => {
    let pdfMenu = [
        {
            id: 'tutorial.manageLibrary.addPDF.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addPDF.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addPDF.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageLibrary.addPDF.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/AddPDF.jpg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLibrary-addPDF'}
            title={'tutorial.manageLibrary.addPDF.title'}
            explanations={pdfMenu}
            imageTop={false}
        />
    );
};

export default AddPDF;
